import {Component, Input, OnInit} from '@angular/core';
import {ChartOptions} from "../../../components/dashboard/apex-hospital-chart/apex-hospital-chart.component";

@Component({
  selector: 'app-apex-bar-graph3',
  templateUrl: './apex-bar-graph3.component.html',
  styleUrls: ['./apex-bar-graph3.component.scss']
})
export class ApexBarGraph3Component implements OnInit {
  public areaChartOptions!: Partial<ChartOptions>;
  @Input() mLabels!: string[]
  @Input() mCount!: any[]
  @Input() title!: string
  constructor() {
  }
  ngOnInit(): void {
    this.areaChart()
  }
  private areaChart() {
    this.areaChartOptions = {
      series: [
        {
          name: this.title,
          data: this.mCount,
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          distributed: true, // Ensure bars are colored individually
        }
      },
      colors: ['#16A085', '#D35400', '#1a628f', '#C0392B', '#27AE60', '#BDC3C7', '#FF6347', '#FF1493', '#6A5ACD'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: this.mLabels
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },

      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
  }
}
